import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

let _ = t => t,
    _t;

import { Fragment, useState } from 'react';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { BATTLESHIP } from 'HubStyleTokens/colors';
import HR from 'UIComponents/elements/HR';
import UILink from 'UIComponents/link/UILink';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import breakpoint from 'pricing-pages-ui/constants/Breakpoints';
import FeatureModalSplitter from '../../feature-modal/FeatureModalFS/FeatureModalSplitter';
const StyledLink = styled(UILink).withConfig({
  displayName: "MobileViewAllFeatures__StyledLink",
  componentId: "vjkx9k-0"
})(["&.features-link{", "}"], breakpoint.phone(_t || (_t = _`
      font-weight: 600;
    `)));
const MobileViewAllFeaturesContainer = styled.div.withConfig({
  displayName: "MobileViewAllFeatures__MobileViewAllFeaturesContainer",
  componentId: "vjkx9k-1"
})(["text-align:center;hr{background-color:", ";margin-bottom:16px !important;}"], BATTLESHIP);

const MobileViewAllFeatures = ({
  productLevel,
  productLine,
  trackingSource
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleMobileViewAllFeaturesModal = () => {
    setIsModalOpen(!isModalOpen);

    if (!isModalOpen) {
      getUsageTracker().track('clickToViewModal', {
        name: 'compare-feature-modal',
        productLine,
        productLevel,
        location: trackingSource
      });
    }
  };

  const MobileViewAllFeaturesContent = /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(StyledLink, {
      onClick: toggleMobileViewAllFeaturesModal,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricingPage.highlightedMerchCards.seeAllFeatures"
      })
    }), isModalOpen && /*#__PURE__*/_jsx(FeatureModalSplitter, {
      onCloseClick: toggleMobileViewAllFeaturesModal,
      productLine: productLine,
      defaultProductLevel: productLevel
    })]
  });

  return /*#__PURE__*/_jsxs(MobileViewAllFeaturesContainer, {
    children: [/*#__PURE__*/_jsx(HR, {
      className: "m-bottom-5"
    }), MobileViewAllFeaturesContent]
  });
};

export default MobileViewAllFeatures;